var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileImportSolid = function SvgFileImportSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v11a2.75 2.75 0 0 1-2.727 2.75H9.078l1.336-1.336a2 2 0 0 0 0-2.828l-3-3a2 2 0 0 0-3.164.445V5Zm9.5 3V3.81l4.44 4.44H14a.25.25 0 0 1-.25-.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53 15.47a.75.75 0 0 0-1.06 1.06l1.72 1.72H2a.75.75 0 0 0 0 1.5h5.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 16.97V17h.017a1.858 1.858 0 0 1-.017-.03ZM4.25 21.03V21h.017l-.017.03Z",
    fill: "currentColor"
  })));
};
export default SvgFileImportSolid;